/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(async function() {
  // Add custom code below this line
  const freeGiftStartTime = new Date(window.theme.settings.freeGiftStartTime)
  const freeGiftEndTime = new Date(window.theme.settings.freeGiftEndTime)
  const today = new Date()

  const handleFreeGift = async () => {
    let hasFreeGift = false;
    let cart = {}
    try {
      cart = window.cartResponse
    } catch (error) {
      cart = await fetch(`${window.Shopify.routes.root}cart.js`).then(response => response.json())
    }

    console.log("cart might be changed", cart);

    const qualifyingTotal = cart.items.reduce((sum, line) => {
      let linePrice = 0
      if (line.product_type != "greeting_card" && line.product_type != "Free Gift") {
        if (line.variant_id != freeGiftVariantId) {
          linePrice = line.original_line_price;
        } else {
          hasFreeGift = true;
        }
      }
      return sum + linePrice
    }, 0);

    if (today > freeGiftStartTime && today < freeGiftEndTime) {
      if (qualifyingTotal >= freeGiftThreshold && !hasFreeGift) {
        const items = [
          {
            quantity: 1,
            id: freeGiftVariantId,
            properties: {
              '_Gifted': "5 Million Trees Planted"
            }
          }
        ]
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({items})
        })
        .then( res => res.json())
        .then(res => {
          
          document.querySelector("cart-items").getCart()
        });
      }
      if (qualifyingTotal < freeGiftThreshold && hasFreeGift) {
        const updates = {
          [freeGiftVariantId]: 0
        }
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({updates})
        })
        .then( res => res.json())
        .then(res => {
          console.log(res)
          
          document.querySelector("cart-items").getCart()
        });
      }
    }
  }

  document.addEventListener("theme:cart:change", handleFreeGift);
  
  setTimeout(() => {
    handleFreeGift()
  }, 1000)


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

